module.exports = __webpack_public_path__ + "static/img/ban.da54d200.gif";